var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item/Icons/Bold/text-align-left"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6109_93337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33594 2.33398H11.6693",
    stroke: "#6C7C83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.33594 11.666H11.6693",
    stroke: "#6C7C83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463453",
    x: 2.33594,
    y: 4.08398,
    width: 5.83333,
    height: 5.83333,
    rx: 1,
    fill: "#6C7C83"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6109_93337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlign);
export default __webpack_public_path__ + "static/media/leftAlign.553c49a82241b5233ffe6740487b1142.svg";
export { ForwardRef as ReactComponent };